import { render, staticRenderFns } from "./DumpsterCommercialForm.vue?vue&type=template&id=38f05dca&scoped=true"
import script from "./DumpsterCommercialForm.vue?vue&type=script&lang=js"
export * from "./DumpsterCommercialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f05dca",
  null
  
)

export default component.exports